<template>
    <!-- 批阅试卷 -->
    <div class="board">
        <div v-hasPermi="['arrangement:answer:find:teacher']" class="h100p">
            <div class="title">
                <span>
                    <el-button type="text" icon="el-icon-arrow-left"
                               @click="$router.push({name:'markingPaper'})">{{ reviewPaperTextConfig.back }}</el-button>
                    <el-divider direction="vertical"></el-divider>
                    <span class="name">{{ reviewPaperTextConfig.title }}</span>
                </span>
            </div>
            <el-progress :stroke-width="20" :percentage="info.reviewedNum/info.reviewTotal*100"
                         :format="progressFormat"></el-progress>

            <div class="questionCon" v-loading="loading" element-loading-text="加载中"
                 element-loading-spinner="el-icon-loading">
                <div class="left" style="max-width:unset">
                    <!--自动重评时显示评委打分及极差信息-->
                    <el-card shadow="never" style="margin-bottom: 10px" v-if="enableTipContent">
                        <el-row>
                            <el-descriptions direction="vertical" :column="7" border>
                                <template slot="title">
                                    <span class="re_tip_class">{{reviewPanelTextConfig.repeatWarningTitle}}（{{ reviewPanelTextConfig.tip.signMix(question.score) }} × {{remark.threshold ? remark.threshold : 15}}% = {{reviewPanelTextConfig.tip.signMix(remark.value)}}）</span>
                                </template>
                                <template v-for="(item, index) in remark.reviewer">
                                    <el-descriptions-item :label="reviewPanelTextConfig.reviewerTitle + (index + 1)">
                                        {{item.name}}
                                    </el-descriptions-item>
                                    <el-descriptions-item :label="reviewPanelTextConfig.scoreTitle">
                                        {{reviewPanelTextConfig.tip.signMix(item.score)}}
                                    </el-descriptions-item>
                                </template>
                                <el-descriptions-item>
                                    <template slot="label">
                                        <div class="range-title-custom">{{reviewPanelTextConfig.scoreRange}}</div>
                                    </template>
                                    {{reviewPanelTextConfig.tip.signMix(remark.range)}}
                                </el-descriptions-item>
                            </el-descriptions>
                        </el-row>
                    </el-card>
                    <!--卷子及答案及解析-->
                    <el-card class="box-card left_question_content" shadow="hover"
                             :style="enableTipContent ? contentHeight2 : contentHeight">
                        <el-collapse
                                v-if="question.crosshead.length || question.training_id || question.attachment.stem">
                            <el-collapse-item name="1">
                                <template slot="title"><p v-html="question.stem" class="ql-editor"></p></template>
                                <div v-for="(n,l) in question.crosshead" :key="l">
                                    <span>（{{ l + 1 }}）</span>
                                    <p v-html="n.newStem" class="ql-editor" style="display:inline-flex;"></p>
                                </div>
                                <p style="margin:10px 0" v-if="question.attachment">
                                    <el-tag v-if="question.attachment.stem" type="medium">
                                        {{ questionTextConfig.attachment }} {{ question.attachment.stem.file_name }}&nbsp;&nbsp;
                                        <el-tooltip class="item" effect="dark" :content="questionTextConfig.preview"
                                                    placement="top"
                                                    v-if="checkFileType(question.attachment.stem.file_name)">
                                            <i class="el-icon-search"
                                               @click="seeIframe(question.attachment.stem.file_path)"
                                               style="cursor: pointer;"></i>
                                        </el-tooltip>&nbsp;
                                        <el-tooltip class="item" effect="dark" :content="questionTextConfig.download"
                                                    placement="top">
                                            <a :href="config_env.BASE_URL + getDownloadAddress(question.attachment.stem.file_path, question.attachment.stem.file_name)"><i
                                                    class="el-icon-download"></i></a>
                                        </el-tooltip>
                                    </el-tag>
                                </p>
                                <el-button v-if="question.training_id" type="primary" icon="el-icon-monitor" size="mini"
                                           style="margin-top:10px" :disabled="true">
                                    {{ question.training_label }}
                                </el-button>
                            </el-collapse-item>
                        </el-collapse>
                        <p v-else v-html="question.stem" class="ql-editor"></p>
                        <ul class="answer" v-if="question.submit_mode && question.submit_mode.includes('text')">
                            <li class="spaceBetween" v-for="(e, i) in form.score" :key="i">
                                <span class="answerLabel">
                                    {{ question.crosshead.length ? '（' + (i + 1) + '）' : ' ' }}{{ answerTextConfig.label }}</span>
                                <div class="answerBox" style="max-height: 200px;">
                                    <p v-html="examineeAnswer.answer[i]" style="margin-bottom:10px"></p>
                                </div>
                            </li>
                        </ul>
                        <ul class="answer" v-if="question.submit_mode && question.submit_mode.includes('link')">
                            <li v-if="examineeAnswer.link">
                                <span class="answerLabel">{{ answerTextConfig.link }}</span>
                                <el-button type="primary" icon="el-icon-link" size="mini" v-if="examineeAnswer.link"
                                           style="margin-top:10px" @click="goToLink(examineeAnswer.link)">
                                    访问链接
                                </el-button>
                            </li>
                        </ul>
                        <ul class="answer" v-if="question.submit_mode && question.submit_mode.includes('attachment')">
                            <li v-if="examineeAnswer.file">
                                <span class="answerLabel">{{ answerTextConfig.attachment }}</span>
                                <el-tag type="medium"
                                        style="margin-top:7px;font-size:14px;line-height:28px;height:28px">
                                    {{ examineeAnswer.fileName }}&nbsp;&nbsp;
                                    <el-tooltip class="item" effect="dark" :content="answerTextConfig.preview"
                                                placement="top"
                                                v-if="checkFileType(examineeAnswer.fileName)">
                                        <i class="el-icon-search" @click="seeIframe(examineeAnswer.file)"
                                           style="cursor: pointer;"></i>
                                    </el-tooltip>&nbsp;
                                    <el-tooltip class="item" effect="dark" :content="answerTextConfig.download"
                                                placement="top">
                                        <a :href="config_env.BASE_URL + getDownloadAddress(examineeAnswer.file, examineeAnswer.fileName)"><i
                                                class="el-icon-download"></i></a>
                                    </el-tooltip>
                                </el-tag>
                            </li>
                        </ul>
                        <hr size="1" dashed="dashed"
                            style="border-top:1px #ddd dashed;margin-bottom:24px;margin-top:24px">
                        <el-button @click="isShow=!isShow">
                            {{ isShow ? correctAnswerTextConfig.retract : correctAnswerTextConfig.expand }}
                            <i :class="isShow?'el-icon-arrow-up':'el-icon-arrow-down'"></i></el-button>
                        <ul v-show="isShow" class="answer" style="color:#8d8d8d">
                            <li>
                                <span class="answerLabel" style="line-height:17px">
                                    {{ correctAnswerTextConfig.label }}</span>
                                <div class="answerBox" style="border:0;padding:0">
                                    <p v-html="questionAnswer.answer[0]"></p>
                                    <el-tag v-if="questionAnswer.answer_file" type="medium">
                                        {{ correctAnswerTextConfig.attachment }}
                                        {{ questionAnswer.answer_file.file_name }}&nbsp;&nbsp;
                                        <el-tooltip class="item" effect="dark"
                                                    :content="correctAnswerTextConfig.preview" placement="top"
                                                    v-if="checkFileType(questionAnswer.answer_file.file_name)">
                                            <i class="el-icon-search" style="cursor: pointer;"
                                               @click="seeIframe(questionAnswer.answer_file.file_path)"></i>
                                        </el-tooltip>
                                        &nbsp;
                                        <el-tooltip class="item" effect="dark"
                                                    :content="correctAnswerTextConfig.download" placement="top">
                                            <a :href="config_env.BASE_URL + getDownloadAddress(questionAnswer.answer_file.file_path, questionAnswer.answer_file.file_name)"><i
                                                    class="el-icon-download"></i></a>
                                        </el-tooltip>
                                    </el-tag>
                                </div>
                            </li>
                            <li>
                                <span class="answerLabel" style="line-height:17px">{{ analysisTextConfig.name }}</span>
                                <div class="answerBox" style="border:0;padding:0">
                                    <p v-html="questionAnswer.analysis"></p>
                                    <el-tag v-if="questionAnswer.analysis_file" type="medium">
                                        {{ analysisTextConfig.attachment }} {{ questionAnswer.analysis_file.file_name }}&nbsp;&nbsp;
                                        <el-tooltip class="item" effect="dark" :content="analysisTextConfig.preview"
                                                    placement="top"
                                                    v-if="checkFileType(questionAnswer.analysis_file.file_name)">
                                            <i class="el-icon-search" style="cursor: pointer;"
                                               @click="seeIframe(questionAnswer.analysis_file.file_path)"></i>
                                        </el-tooltip>&nbsp;
                                        <el-tooltip class="item" effect="dark" :content="analysisTextConfig.download"
                                                    placement="top">
                                            <a :href="config_env.BASE_URL + getDownloadAddress(questionAnswer.analysis_file.file_path, questionAnswer.analysis_file.file_name)"><i
                                                    class="el-icon-download"></i></a>
                                        </el-tooltip>
                                    </el-tag>
                                </div>
                            </li>
                        </ul>
                    </el-card>
                </div>

                <div class="right">
                    <el-card class="box-card" shadow="hover" style="height:100%;box-sizing:border-box;">
                        <p class="computeScore">批阅ID
                            <span>
                            </span>{{form.id}}</p>
                        <p class="computeScore">{{ reviewPanelTextConfig.name }}
                            <span>{{ reviewPanelTextConfig.tip.signMix((totalScore || totalScore === 0) ? totalScore : '?') }}
                            </span> / {{ reviewPanelTextConfig.tip.signMix(question.score) }}</p>
                        <el-form ref="form" :model="form" :label-width="question.crosshead.length?'94px':'52px'"
                                 style="height: calc(100% - 200px);overflow: auto;">
                            <el-form-item
                                    :label="question.crosshead.length?'（'+(i+1)+'）' + reviewPanelTextConfig.score:reviewPanelTextConfig.score"
                                    v-for="(e,i) in form.score" :key="i"
                                    :prop="'score['+i+']'" :rules="[
                                    { required: true, message: reviewPanelTextConfig.scoreRule, trigger: 'change' },
                                    { validator: validateScore, trigger: 'change' }
                                ]">
                                <el-input type="number" v-model="form.score[i]"
                                          :placeholder="reviewPanelTextConfig.scoreTip"></el-input>
                            </el-form-item>
                            <el-form-item :label="reviewPanelTextConfig.comment">
                                <el-input type="textarea" :rows="4" v-model="form.comment"
                                          :placeholder="reviewPanelTextConfig.commentTip"
                                          maxlength="500" show-word-limit clearable></el-input>
                            </el-form-item>
                        </el-form>
                        <ar-review-btn v-if="questionApplication" class="hidden" ar-btn-label="AI评阅结果"
                                       ar-modal-title="AI评阅结果"
                                       ar-btn-class="ar-vue-button ar-vue-button-primary ar-vue-button-small ar-mg-10 ar-float-right"
                                       ar-modal-class="ar-modal-min"
                                       :ar-get-data-url="getAiReviewQuestionReviewUri(form.id)"
                                       @ar-review-trigger="getUserQuestionReview(form.id)">
                        </ar-review-btn>
                        <el-button v-hasPermi="['review:next']" type="primary" style="width:100%" @click="saveReview">
                            {{ reviewPanelTextConfig.save }}
                        </el-button>
                        <p v-hasPermi="['review:next']" class="info">{{ reviewPanelTextConfig.saveTip }}</p>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import quillEditor from '@/components/editor/index.vue'
    import {getDownloadAddress} from '@/utils/common.js'
    import {getExamPaperAnswerByAdmin} from "@/api/arrangement";
    import {getQuestionReviewResult} from "@/api/reviewResult";
    import {getAnswerSheetByAdmin} from "@/api/exam";
    import {getAiReviewQuestionReviewUri, getApplicationByQuestionIds, getConfig} from "@/api/aiReview";
    import '@/utils/ai-review.js'

    window.aiReviewConfig = {
        apiService: {},
        client: {}
    }

    /**
     * 批阅赛卷页面
     */
    export default {
        components: {
            quillEditor,
        },
        data() {
            return {
                loading: true,
                status: 0,
                question: {attachment: {}, crosshead: []}, // 题目
                questionApplication: {},
                examineeAnswer: {answer: []}, // 考生答案
                questionAnswer: {answer: []}, // 题目答案
                isShow: false,
                info: {},
                form: {
                    id: null,
                    score: [''],
                    comment: '',
                    remark: '',
                },
                totalScore: null,
                remark: {
                    value: 0,
                    reviewer: [
                        {name: '', score: ''}
                    ],
                    range: '',
                },
                reviewItem: {},
                contentHeight: {
                    height: '100%'
                },
                contentHeight2: {
                    height: 'calc(100% - 165px)'
                }
            }
        },
        beforeCreate() {
            getConfig().then(res => {
                window.aiReviewConfig = res.data
            })
        },
        computed: {
            enableTipContent() {
                return this.reviewItem.questionReviewStatus === 2 && this.reviewItem.remark
            },
            reviewPaperTextConfig() {
                return this.$store.state.global.textConfig.backend.reviewPaper
            },
            questionTextConfig() {
                return this.reviewPaperTextConfig.question
            },
            answerTextConfig() {
                return this.reviewPaperTextConfig.answer
            },
            correctAnswerTextConfig() {
                return this.reviewPaperTextConfig.correctAnswer
            },
            analysisTextConfig() {
                return this.reviewPaperTextConfig.analysis
            },
            reviewPanelTextConfig() {
                return this.reviewPaperTextConfig.reviewPanel
            },
            fileTypeList() {
                if (this.$store.state.global.textConfig.filePreview && this.$store.state.global.textConfig.filePreview.extensions) {
                    let extensions = this.$store.state.global.textConfig.filePreview.extensions;
                    return extensions.replaceAll(' ', '').split(',');
                } else {
                    return ['ipynb', 'jpg', 'png', 'docx', 'doc', 'csv', 'txt', 'xlsx'];
                }
            }
        },
        created() {
            let reviewInfo = JSON.parse(localStorage.getItem('setPaperReviewInfo'))
            this.info = reviewInfo
            this.form.id = reviewInfo.id
            this.getQuestionApplication(reviewInfo.questionId)
            this.getQuestion(reviewInfo.examPaperId, reviewInfo.questionId)
            this.getQuestionAnswer(reviewInfo.examPaperId, reviewInfo.questionId)
            this.getExamineeAnswer(reviewInfo.answerSheetId)
        },
        methods: {
            getAiReviewQuestionReviewUri,
            getDownloadAddress,
            progressFormat(percentage) {
                return `已批阅 ${this.info.reviewedNum} / ${this.info.reviewTotal}`;
            },
            validateScore(rule, value, callback, pars) {
                this.totalScore = null
                let str = JSON.stringify(pars)
                let i = str.match(/\[(.+?)\]/g)[0].replace("[", "").replace("]", "") * 1 + 1
                let val = value * 1, test = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,1})?$/g.test(value)
                if (test === false) {
                    callback(new Error('仅允许输入小数点后1位'));
                } else {
                    if (this.question.crosshead.length) {
                        const score = this.question.crosshead[i - 1].score
                        if (val > score && value) {
                            callback(new Error(this.reviewPanelTextConfig.crossheadRuleError));
                        }
                        this.totalScore = 0
                        for (let j = 0; j < this.form.score.length; j++) {
                            const e = this.form.score[j] * 1;
                            this.totalScore += e
                        }
                    } else {
                        if (val > this.question.score && value) {
                            callback(new Error(this.reviewPanelTextConfig.questionRuleError));
                        }
                        this.totalScore = val
                    }

                    this.totalScore = this.totalScore.toFixed(1)
                }
                callback()
            },
            checkFileType(name) {
                let type = name.split('.')
                if (this.fileTypeList.indexOf(type[1]) === -1) {
                    return false
                } else {
                    return true
                }
            },
            seeIframe(url) {
                window.open(this.FILE_PREVIEW_URL + '/onlinePreview?url=' + encodeURIComponent(this.config_env.BASE_URL + url));
            },
            getQuestion(examPaperId, questionId) {
                this.$store.dispatch('getExamPaperById', examPaperId).then(res => {
                    if (res.status === 200) {
                        //赛卷所有题目
                        let list = res.data.confirmed_paper
                        let filterQuestionType = list.find(questionType => questionType.question_type === 'subjectivity')
                        if (filterQuestionType) {
                            let findQuestion = filterQuestionType.question_list.find(x => x.id === questionId)
                            let scoreArray = []
                            if (findQuestion) {
                                if (findQuestion.crosshead && findQuestion.crosshead.length > 0) {
                                    findQuestion.crosshead.forEach(() => scoreArray.push(''))
                                    this.form.score = scoreArray
                                } else {
                                    this.form.score = ['']
                                }
                                if (!findQuestion.attachment) {
                                    findQuestion.attachment = {}
                                }
                                this.question = findQuestion
                                //获取历史评分
                                this.getUserQuestionReview(this.form.id)
                            }
                        }
                        setTimeout(() => {
                            this.loading = false
                        }, 300);
                    }
                })
            },
            getQuestionAnswer(id, questionId) {
                getExamPaperAnswerByAdmin(id).then(res => {
                    if (res.status === 200) {
                        this.questionAnswer = res.data[questionId]
                    }
                })
            },
            getQuestionApplication(questionId) {
                getApplicationByQuestionIds(questionId).then(res => {
                    if (res.status === 200 && res.data) {
                        this.questionApplication = res.data[0]
                    }
                })
            },
            getUserQuestionReview(reviewerQuestionId) {
                getQuestionReviewResult(reviewerQuestionId).then(res => {
                    if (res.status === 200 && Object.keys(res.data).length > 0) {
                        this.reviewItem = res.data;
                        if (res.data.reviewResult) {
                            let result = JSON.parse(res.data.reviewResult);
                            this.form.comment = result.comment
                            this.totalScore = res.data.score
                            try {
                                if (res.data.remark) {
                                    this.remark = JSON.parse(res.data.remark)
                                }
                            } catch (e) {
                                console.error(e)
                            }
                            for (let i = 0; i < result.score.length; i++) {
                                this.$set(this.form.score, i, result.score[i].toFixed(1))
                            }
                        }
                    }
                })
            },
            getExamineeAnswer(id) {
                getAnswerSheetByAdmin(id).then(res => {
                    if (res.status === 200) {
                        let answer = res.data.questionAnswerList
                        let already = answer.find(item => item.questionId === this.info.questionId)
                        if (already) {
                            this.examineeAnswer = already
                        } else {
                            this.examineeAnswer = {
                                questionId: this.info.questionId,
                                answer: [],
                                id: null
                            }
                        }
                        this.loading = false
                    }
                });
            },
            saveReview() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.$store.dispatch('postReviewResult', this.form).then(res => {
                            if (res.status === 200) {
                                if (this.info.reviewedNum < this.info.reviewTotal - 1) {
                                    this.$message({type: 'success', message: this.reviewPanelTextConfig.success});
                                    this.$store.dispatch('getNextReview', this.info.reviewerId).then(res => {
                                        if (res.status === 200) {
                                            this.totalScore = null
                                            // if (this.question.crosshead) {
                                            //     for (let i = 0; i < this.question.crosshead.length - 1; i++) {
                                            //         this.form.score.push('')
                                            //     }
                                            // }
                                            this.form.id = res.data.id
                                            this.form.comment = ''
                                            this.form.score = ['']
                                            this.form.remark = ''
                                            this.$refs['form'].resetFields();
                                            this.info.id = res.data.id
                                            this.info.answerId = res.data.answerId
                                            this.info.reviewTotal = res.data.reviewTotal
                                            this.info.reviewedNum = res.data.reviewedNum
                                            localStorage.setItem('setPaperReviewInfo', JSON.stringify(this.info))
                                            let markingPaperInfo = JSON.parse(localStorage.getItem('setMarkingPaperInfo'))
                                            markingPaperInfo.reviewedNum = res.data.reviewedNum
                                            localStorage.setItem('setMarkingPaperInfo', JSON.stringify(markingPaperInfo))
                                            this.getExamineeAnswer(res.data.answerId)
                                            this.getQuestion(this.info.examPaperId, this.info.questionId)
                                        }
                                    })
                                } else {
                                    this.$message({type: 'success', message: this.reviewPanelTextConfig.complete});
                                    this.$router.push({name: 'markingPaper'})
                                    // this.$route.meta.keepAlive = false
                                    let markingPaperInfo = JSON.parse(localStorage.getItem('setMarkingPaperInfo'))
                                    markingPaperInfo.reviewedNum = markingPaperInfo.reviewTotal
                                    localStorage.setItem('setMarkingPaperInfo', JSON.stringify(markingPaperInfo))
                                }
                            }
                        })
                    }
                })
            },
            goToLink(url) {
                window.open(url, '_blank');
            }
        }
    }
</script>
<style scoped>
    .left_question_content {
        /*height: 100%;*/
        max-width: 1100px;
        overflow: auto;
        margin: auto;
        box-sizing: border-box;
    }

    .range-title-custom {
        background-color: #4d90fe;
        color: white;
        margin: -8px -10px;
        line-height: 35px;
    }

    .re_tip_class {
        color: darkorange;
        font-weight: bold;
    }

    .spaceBetween {
        display: flex;
        justify-content: space-between;
        margin-top: 14px;
    }

    .el-progress >>> .el-progress-bar {
        padding: 0;
    }

    .el-progress >>> .el-progress__text {
        position: absolute;
        left: 45%;
        top: 2px;
        font-size: 16px !important;
        color: #fff;
    }

    .el-progress >>> .el-progress-bar__outer {
        background-color: rgb(0 112 222 / 28%);
    }

    .questionCon {
        height: calc(100% - 138px);
        margin-top: 20px;
    }

    .questionCon .right .box-card >>> .el-card__body {
        height: 100%;
    }

    .el-collapse >>> .el-collapse-item__header {
        height: max-content;
        padding: 10px;
    }

    .el-collapse >>> .el-collapse-item__content {
        padding-bottom: 10px;
    }

    .answer {
        list-style: none;
        font-size: 14px;
        padding-left: 0;
    }

    .answer li {
        display: flex;
        margin-top: 20px;
    }

    .answer li .answerLabel {
        line-height: 40px;
        width: 90px;
    }

    .answer li .answerBox {
        width: calc(100% - 90px);
        overflow: auto;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        line-height: 20px;
    }

    .computeScore {
        text-align: center;
        font-size: 16px;
        margin-bottom: 20px;
    }

    .computeScore span {
        font-size: 18px;
        font-weight: 600;
        margin-left: 20px;
    }

    .info {
        font-size: 13px;
        text-align: center;
    }

    .ql-editor >>> .el-tag.el-tag--info {
        margin-left: 10px;
    }

    .el-collapse >>> .el-collapse-item__arrow {
        font-size: 24px;
        color: #fff;
        background-color: #0070de;
        border-radius: 50%;
    }

    /deep/ .el-descriptions .is-bordered .el-descriptions-item__cell {
        width: fit-content !important;
    }
</style>
